import { useContext } from 'react';
import {
  FORM_COMPONENTS_TYPES,
  FORM_VALIDATION_TYPES,
  FormBuilder
} from '@namespace/forms';
import { useI18n } from '@namespace/i18n';
import { UserContext } from '@namespace/user';

import styles from './index.module.css';

const NewPassword = ({ onSuccess = () => {}, errorCode = '' }) => {
  const [user] = useContext(UserContext);
  const { email } = user;
  const { t } = useI18n();
  const defaultValues = {
    newPassword: '',
    repeatNewPassword: ''
  };

  const componentsList = [
    {
      type: FORM_COMPONENTS_TYPES.PASSWORD_FIELD,
      name: 'newPassword',
      label: 'passwordRecovery.newPassword.label',
      placeholder: 'passwordRecovery.newPassword.placeholder',
      classNames: {
        inputClassName: styles.input,
        labelClassName: styles.label,
        wrapperClassName: styles.inputWrapper
      },
      size: 'm',
      rulesList: [
        {
          label: ['validation.lessMore', ['6', '14']],
          rules: /^.{6,14}$/
        }
      ],
      validationTypes: [
        FORM_VALIDATION_TYPES.REQUIRED,
        {
          type: FORM_VALIDATION_TYPES.PASSWORD_ASYNC,
          parameters: [email]
        }
      ]
    },
    {
      type: FORM_COMPONENTS_TYPES.REPEAT_PASSWORD,
      inputType: 'password',
      name: 'repeatNewPassword',
      label: 'passwordRecovery.repeatNewPassword.label',
      placeholder: 'passwordRecovery.repeatNewPassword.placeholder',
      validationTypes: [FORM_VALIDATION_TYPES.REQUIRED],
      size: 'm',
      isOnChangeValidation: true,
      classNames: {
        inputClassName: styles.input,
        labelClassName: styles.label,
        wrapperClassName: styles.newPasswordWrapper
      }
    }
  ];

  if (errorCode) {
    componentsList.push({
      type: FORM_COMPONENTS_TYPES.INFO_MESSAGE,
      icon: 'error',
      label: t(`accountingMessages.${errorCode}`),
      classNames: {
        wrapperClassName: styles.errorWrap,
        labelClassName: styles.error
      }
    });
  }

  componentsList.push({
    type: FORM_COMPONENTS_TYPES.SUBMIT_BUTTON,
    view: 'primaryFull',
    value: 'passwordRecovery.continueButton',
    classNames: {
      className: styles.submitButton
    }
  });

  return (
    <FormBuilder
      components={componentsList}
      formConfig={{ defaultValues }}
      onSubmit={onSuccess}
    />
  );
};

export default NewPassword;
